var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.833 8a6.167 6.167 0 1112.334 0A6.167 6.167 0 011.833 8z",
    fill: "#fff",
    stroke: "#F74F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.083 8h5.834",
    stroke: "#F74F4F",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuODMzMjUgNy45OTk5MkMxLjgzMzI1IDQuNTk0MTYgNC41OTQxNiAxLjgzMzI1IDcuOTk5OTIgMS44MzMyNUMxMS40MDU3IDEuODMzMjUgMTQuMTY2NiA0LjU5NDE2IDE0LjE2NjYgNy45OTk5MkMxNC4xNjY2IDExLjQwNTcgMTEuNDA1NyAxNC4xNjY2IDcuOTk5OTIgMTQuMTY2NkM0LjU5NDE2IDE0LjE2NjYgMS44MzMyNSAxMS40MDU3IDEuODMzMjUgNy45OTk5MloiIGZpbGw9IndoaXRlIiBzdHJva2U9IiNGNzRGNEYiLz4KPHBhdGggZD0iTTUuMDgzMjUgOEgxMC45MTY2IiBzdHJva2U9IiNGNzRGNEYiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgDeleteTag as ReactComponent };